import { Fragment, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Cookie from '../Components/Cookie';
import Reviews, { Review } from '../Components/Reviews';
import RequestButton from '../Components/RequestButton';
import LimitedPlacesNotification from '../Components/LimitedPlacesNotification';
import { RatingLogos } from '../Components/ShortSummaryLogos';
import AanvragenAndPostcodeCheck from '../Components/AanvragenAndPostcodeCheck';
import { Link } from 'react-router-dom';
// #DB1F6A

export default function Privacy() {
  return (
    <Fragment>
        
        <Header activePage="/privacy.html" />

		<LimitedPlacesNotification />

		<div className="md:hidden">
			<img alt="twee vrouwen die met elkaar praten" className="header-bg-clip bg-cover" src="/assets/images/intakekraamtijd-header-sm.jpg" />
		</div>

		<div className="md:container-fluid md:bg-ervaringen-header md:h-[24rem] md:bg-no-repeat md:bg-right md:bg-[#666666]  md:header-bg-clip md:bg-contain">
			<div className="container mx-auto py-4 lg:py-7 flex justify-start">
				<div className="md:w-[65%] lg:w-[45%] md:bg-black md:bg-opacity-40 md:box-border md:rounded-lg md:z-10 md:relative">

                    
				</div>
			</div>
		</div>



        <div className="md:container-fluid mt-16">
			<div className="container mx-auto justify-end">
                <div className="p-4 lg:p-0">

                    <h1 className="text-3xl">Privacyverklaring Kraamzorg Mama</h1>

                    <p className="py-4 text-lg">  
                        Deze pagina is voor het laatst aangepast op 13-01-2022. Wij zijn er van bewust dat u vertrouwen 
                        stelt in ons. Wij zien het dan ook als onze verantwoordelijkheid om uw privacy te beschermen. Op 
                        deze pagina laten we u weten welke gegevens we verzamelen als u onze website gebruikt, waarom we 
                        deze gegevens verzamelen en hoe we hiermee uw gebruikservaring verbeteren. Zo snapt u precies hoe 
                        wij werken. Dit privacybeleid is van toepassing op de diensten van Vérian. U dient zich ervan 
                        bewust te zijn dat Vérian niet verantwoordelijk is voor het privacybeleid van andere sites en 
                        bronnen. Door gebruik te maken van deze website geeft u aan het privacybeleid te accepteren. 
                        Vérian respecteert de privacy van alle gebruikers van haar site en draagt er zorg voor dat de 
                        persoonlijke informatie die u ons verschaft, vertrouwelijk wordt behandeld.
                    </p>

                    <h2 className="text-2xl py-2">Ons gebruik van verzamelde gegevens</h2>

                    <h3 className="text-xl py-2 italic">Gebruik van onze diensten</h3>

                    <p className="text-lg py-2">
                        Wanneer u zich aanmeldt voor kraamzorg vragen we u om persoonsgegevens te verstrekken. Deze gegevens 
                        worden gebruikt om de zorg uit te kunnen voeren. De gegevens worden opgeslagen op beveiligde NEN 
                        gecertificeerde servers. Dit geldt tevens voor gegevens die u verstrekt tijdens het intake periode.
                    </p>

                    <h3 className="text-xl py-2 italic">Communicatie</h3>

                    <p className="text-lg py-2">
                        Wanneer u een e-mail of andere berichten naar ons stuurt, is het mogelijk dat we die berichten bewaren. 
                        Soms vragen wij u naar uw persoonlijke gegevens die voor de desbetreffende situatie relevant zijn. Dit 
                        maakt het mogelijk uw vragen te verwerken en uw verzoeken te beantwoorden. 
                    </p>

                    <h3 className="text-xl py-2 italic">Cookies</h3>
                    
                    <p className="text-lg py-2">
                        Wij verzamelen gegevens voor onderzoek om zo een beter inzicht te krijgen in onze klanten, zodat wij 
                        onze diensten hierop kunnen afstemmen. Deze website maakt gebruik van ‘cookies’ (tekstbestanden die 
                        op uw computer worden geplaatst) om de website te helpen analyseren hoe gebruikers de site gebruiken. 
                        De door het cookie gegenereerde informatie over uw gebruik van de website kan worden overgebracht naar 
                        NEN beveiligde servers van Kraamzorg Mama of die van een derde partij. Wij gebruiken deze informatie 
                        om bij te houden hoe u de website gebruikt, om rapporten over de website-activiteit op te stellen en 
                        andere diensten aan te bieden met betrekking tot website-activiteit en internetgebruik.
                    </p>

                    <h3 className="text-xl py-2 italic">Doeleinden</h3>

                    <p className="text-lg py-2">
                        We verzamelen of gebruiken geen informatie voor andere doeleinden dan de doeleinden die worden 
                        beschreven in dit privacybeleid tenzij we van tevoren uw toestemming hiervoor hebben verkregen.
                    </p>
                    
                    <h3 className="text-xl py-2 italic">Derden</h3>

                    <p className="text-lg py-2">
                        De informatie wordt niet met derden gedeeld. In enkele gevallen kan de informatie intern gedeeld worden. 
                        Onze werknemers zijn verplicht om de vertrouwelijkheid van uw gegevens te respecteren. Veranderingen 
                        in deze privacyverklaring is afgestemd op het gebruik van en de mogelijkheden op deze site. Eventuele 
                        aanpassingen en/of veranderingen van deze site, kunnen leiden tot wijzigingen in deze privacyverklaring.
                    </p>

                    <p className="text-lg py-2">
                        Het is daarom raadzaam om regelmatig deze privacyverklaring te raadplegen. Wij bieden alle bezoekers 
                        de mogelijkheid tot het inzien, veranderen, of verwijderen van alle persoonlijke informatie die op 
                        moment aan ons is verstrekt.
                    </p>

                    <h3 className="text-xl py-2 italic">Aanpassen/uitschrijven communicatie</h3>

                    <p className="text-lg py-2"> 
                        Als u uw gegevens aan wilt passen of uzelf uit onze bestanden wilt laten halen, kunt u contact met ons 
                        opnemen. Zie onderstaande contactgegevens.
                    </p>

                    <h3 className="text-xl py-2 italic">Cookies uitzetten</h3>

                    <p className="text-lg py-2">
                        De meeste browsers zijn standaard ingesteld om cookies te accepteren, maar u kunt uw browser opnieuw 
                        instellen om alle cookies te weigeren of om aan te geven wanneer een cookie wordt verzonden. Het is 
                        echter mogelijk dat sommige functies en –services, op onze en andere websites, niet correct functioneren 
                        als cookies zijn uitgeschakeld in uw browser.
                    </p>

                    <h2 className="text-2xl py-2">Privacybeleid</h2>
                    <p className="text-lg py-2">
                        Heeft u vragen over hoe privacy is geregeld bij Kraamzorg Mama? Stuur dan een mail 
                        naar: <Link className="text-blue" to="mailto:sr.kwaliteit@kraamzorgmama.nl">sr.kwaliteit@kraamzorgmama.nl</Link>
                    </p>
                </div>

            </div>
        </div>

        <AanvragenAndPostcodeCheck />




        <Footer />

		<Cookie />

    </Fragment>
  );
}

